import { render, staticRenderFns } from "./SimpleForm.vue?vue&type=template&id=d634ffee&scoped=true"
import script from "./SimpleForm.vue?vue&type=script&lang=ts"
export * from "./SimpleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d634ffee",
  null
  
)

export default component.exports